module.exports = __webpack_public_path__ + "static/media/gym-marker-selected.d04d59ca.svg";